import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
/**
 * Filterkomponente für Tabellenspalten, die es ermöglich, einen Datumsbereich anzugeben.
 *
 * Der Wert des Filters ist ein Objekt mit den Properties "from" und "to", die die Datums- bzw. Zeitpunktangaben als ISO-Strings enthalten.
 * Sowohl from als auch to ist optional.
 * Der Zeitpunkt im ISO-String ist immer 00:00 Uhr Ortszeit. Aufgrund der Normierung auf "Z" wird das bei MEZ typischerweise
 * als 22:00 bzw. 23:00 im ISO-String erscheinen.
 *
 * Das TableHttpClientUrlParamsUtil beherrscht mittlerweile die Konvertierung von Date in ISO-Strings.
 * Aus Gründen der Abwärtskomapatibilität wird dies hier aber weiterhin direkt in der Komponente getan.
 *
 * @author stoc
 */
@Component({
    selector: 'common-table-date-range-filter',
    templateUrl: 'table-date-range-filter.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TableDateRangeFilterComponent),
            multi: true
        }
    ]
})
export class TableDateRangeFilterComponent implements ControlValueAccessor {

    /**
     * Das Anfangsdatum.
     */
    fromDate: Date;

    /**
     * Das Enddatum.
     */
    toDate: Date;

    disabled: boolean = false;

    private onChange: (values: {from: string, to: string}) => void;

    onChangeFromOrTo() {
        this.onChange({
            from: this.fromDate && this.fromDate.toISOString(),
            to: this.toDate && this.toDate.toISOString()
        });
    }

    writeValue(value: any): void {
        this.fromDate = value && value.from && new Date(value.from);
        this.toDate = value && value.to && new Date(value.to);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {

    }

    setDisabledState(isDisabled: boolean) {
        this.disabled = isDisabled;
    }

}
